/**
 * Роль точки в типичном пешеходном маршруте city-quest.
 * Согласовано с seed (`todo/city-attractions`): well_known → primary.
 */
export enum AttractionRouteRoleEnum {
    ANCHOR = 'anchor',
    PRIMARY = 'primary',
    CONNECTOR = 'connector',
    OPTIONAL = 'optional',
    DETOUR = 'detour',
}
